// Sidebar.js

import React from "react";
import { Box, Button, Divider } from "@mui/material";
import cookie from "../../../API/cookie";

//user_id cookie
var defaultValue;

let user_id = cookie.getCookie("userAccount")
  ? cookie.getCookie("userAccount")
  : "";
var api_token = cookie.getCookie("accessToken");

if (user_id) {
  defaultValue = {
    key: api_token,
  };
}

//관리자 여부 판단 (is_staff: 0=일반, 1=슈퍼관리자, 2=제한관리자)
const rawIsStaff = cookie.getCookie("is_staff");
const isStaff = ["true", "1", "2"].includes(String(rawIsStaff ?? "false").toLowerCase());

const Sidebar = () => {
  const publicUrl = process.env.PUBLIC_URL;
  return (
    <>
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          width: { xs: 0, md: 300 },
          backgroundColor: "#333333",
        }}
      >
        {/* 로고 */}
        <Box
          sx={{
            justifyContent: "center",
            display: "flex",
            height: 66,
            alignItems: "center",
          }}
        >
          <a href="/">
            <img
              style={{ width: "auto", height: 30, paddingRight: 20 }}
              alt="home icon"
              src={`${publicUrl}/logo.png`}
            />
          </a>
        </Box>

        <Divider sx={{ borderColor: "#444444" }} />

        {isStaff && (
          <Box
            sx={{
              mt: 2,
              px: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {/* 관리자 전용 버튼들 */}

            {/* 메인 자극 레시피 화면 */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#555555",
                "&:hover": { backgroundColor: "#666666" },
              }}
              onClick={() =>
                window.dispatchEvent(
                  new CustomEvent("stim:navigate", {
                    detail: { view: "main" },
                  })
                )
              }
            >
              자극 레시피
            </Button>

            {/* 레시피 관리 화면 */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#555555",
                "&:hover": { backgroundColor: "#666666" },
              }}
              onClick={() =>
                window.dispatchEvent(
                  new CustomEvent("stim:navigate", {
                    detail: { view: "recipeManage" },
                  })
                )
              }
            >
              자극 레시피 관리
            </Button>

            {/* 커스텀 자극 생성기 화면 */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#555555",
                "&:hover": { backgroundColor: "#666666" },
              }}
              onClick={() =>
                window.dispatchEvent(
                  new CustomEvent("stim:navigate", {
                    detail: { view: "stimManager" },
                  })
                )
              }
            >
              커스텀 자극 생성기
            </Button>

            {/* 유저 관리 화면 */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#555555",
                "&:hover": { backgroundColor: "#666666" },
              }}
              onClick={() =>
                window.dispatchEvent(
                  new CustomEvent("stim:navigate", {
                    detail: { view: "userManage" },
                  })
                )
              }
            >
              유저 관리
            </Button>


            {/* 그룹 관리 화면 */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#555555",
                "&:hover": { backgroundColor: "#666666" },
              }}
              onClick={() =>
                window.dispatchEvent(
                  new CustomEvent("stim:navigate", {
                    detail: { view: "groupManage" },
                  })
                )
              }
            >
              그룹 관리
            </Button>

            
            {/* 🔹 기기 재연결 시도 버튼 */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: "#555555",
                "&:hover": { backgroundColor: "#666666" },
              }}
              onClick={() =>
                window.dispatchEvent(new CustomEvent("stim:reconnect"))
              }
            >
              기기 재연결 시도
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default Sidebar;
